import { HttpInterceptorFn } from '@angular/common/http';
import { NgZone, inject } from '@angular/core';
import { Observable } from 'rxjs';

/** Re-enters the Angular zone on HTTP events so views update without a user click. */
export const angularZoneInterceptor: HttpInterceptorFn = (request, next) => {
   const zone = inject(NgZone);

   return new Observable((subscriber) => {
      const subscription = next(request).subscribe({
         next: (event) => runInAngularZone(zone, () => subscriber.next(event)),
         error: (error) => runInAngularZone(zone, () => subscriber.error(error)),
         complete: () => runInAngularZone(zone, () => subscriber.complete()),
      });

      return () => subscription.unsubscribe();
   });
};

function runInAngularZone(zone: NgZone, work: () => void): void {
   if (NgZone.isInAngularZone()) {
      work();
      return;
   }

   zone.run(work);
}
